import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule, CheckboxModule, DataTableModule, RadioButtonModule, Tooltip, TooltipModule } from 'primeng/primeng';
import { ApiService } from '../api/services/api.service';
import { SyncOverlayService } from '../services/sync-overlay.service';
import { AppConnectivityComponent } from './app-connectivity/app-connectivity.component';
import { ContainerCollapseDirective } from './container-collapse/container-collapse.directive';
import { DropdownDirective } from './dropdown.directive';
import { FirmwareUpgradeProgressComponent } from './firmware-upgrade-progress/firmware-upgrade-progress.component';
import { GatewayIdValidatorPipe } from './gateway-id-validator-.pipe';
import { GatewayStatusComponent } from './gateway-status/gateway-status.component';
import { ImageAssetDirective } from './image-asset.directive';
import { ImageSelectionComponent } from './image-selection/image-selection.component';
import { InnerHtmlStylingPipe } from './inner-html-styling.pipe';
import { KeysPipe } from './keys.pipe';
import { LightingProgressCircleComponent } from './lighting-progress-circle/lighting-progress-circle.component';
import { LightingThemeProgressCircleComponent } from './lighting-theme-progress-circle/lighting-theme-progress-circle.component';
import { LimitPipe } from './limit.pipe';
import { LoadingComponent } from './loading/loading.component';
import { ManualRuntimeInputRestrictorDirective } from './manual-runtime-input-restrictor';
import { MessageBoxComponent } from './message-box/message-box.component';
import { NoSpaceValidatorDirective } from './no-space.directive';
import { NumInputRestrictorDirective } from './num-input-restrictor.directive';
import { PhonePipe } from './phone.pipe';
import { ProgressCircleComponent } from './progress-circle/progress-circle.component';
import { RuntimePickerComponent } from './runtime-picker/runtime-picker.component';
import { SafePipe } from './safe.pipe';
import { SmCliInputRestrictorDirective } from './sm-cli-input-restrictor';
import { StationRuntimePipe } from './station-runtime.pipe';
import { SyncOverlayComponent } from './sync-overlay/sync-overlay.component';
import { ThemeDirective } from './theme.directive';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { WateringDaysPipe } from './watering-days.pipe';

@NgModule({
    imports: [
        CommonModule,
        DataTableModule,
        RadioButtonModule,
        DialogModule,
        TooltipModule
    ],
    declarations: [
        ProgressCircleComponent,
        LightingProgressCircleComponent,
        LightingThemeProgressCircleComponent,
        SyncOverlayComponent,
        ThemeDirective,
        LoadingComponent,
        ContainerCollapseDirective,
        DropdownDirective,
        ImageAssetDirective,
        LimitPipe,
        PhonePipe,
        GatewayIdValidatorPipe,
        KeysPipe,
        StationRuntimePipe,
        WateringDaysPipe,
        InnerHtmlStylingPipe,
        NumInputRestrictorDirective,
        SmCliInputRestrictorDirective,
        ManualRuntimeInputRestrictorDirective,
        MessageBoxComponent,
        FirmwareUpgradeProgressComponent,
        AppConnectivityComponent,
        ImageSelectionComponent,
        TimePickerComponent,
        SafePipe,
        RuntimePickerComponent,
        NoSpaceValidatorDirective,
        GatewayStatusComponent
    ],
    exports: [
        CommonModule,
        CalendarModule,
        CheckboxModule,
        DataTableModule,
        RadioButtonModule,
        TooltipModule,
        ProgressCircleComponent,
        LightingProgressCircleComponent,
        LightingThemeProgressCircleComponent,
        SyncOverlayComponent,
        ThemeDirective,
        LoadingComponent,
        ContainerCollapseDirective,
        DropdownDirective,
        ImageAssetDirective,
        LimitPipe,
        PhonePipe,
        GatewayIdValidatorPipe,
        KeysPipe,
        StationRuntimePipe,
        InnerHtmlStylingPipe,
        NumInputRestrictorDirective,
        SmCliInputRestrictorDirective,
        ManualRuntimeInputRestrictorDirective,
        WateringDaysPipe,
        FirmwareUpgradeProgressComponent,
        AppConnectivityComponent,
        DialogModule,
        ImageSelectionComponent,
        TimePickerComponent,
        SafePipe,
        RuntimePickerComponent,
        NoSpaceValidatorDirective,
        GatewayStatusComponent
    ],
    providers: [
        SyncOverlayService,
        ApiService
    ]
})
export class SharedModule {
}
